export default __webpack_public_path__ + "1420f8bd38621b5fdeffeb9a47e52880.svg";